import api from './api'

const ACTION_LABELS = {
  VIEW_COURSE: { label: 'Explore this course', support: 'See this program on the SMA site.' },
  START_APPLICATION: { label: 'Start my application', support: 'Begin your SMA application.' },
  VIEW_MASTERCLASS: { label: 'Explore Masterclass', support: 'See upcoming Masterclass sessions.' },
  VIEW_SHOWCASE: { label: 'View student work', support: 'Open the SMA showcase.' },
  VIEW_MENTORS: { label: 'Meet the mentors', support: 'See who teaches at SMA.' },
  CONTACT_ADMISSIONS: { label: 'Talk to Admissions', support: 'Connect with SMA Admissions.' },
  BACK_TO_EXPLORE: { label: 'Back to Explore SMA', support: 'Return to the academy site.' },
}

export function mapAdvisorActions(actions, conversationId) {
  return (actions || []).map((action, index) => {
    const meta = ACTION_LABELS[action.type]
    if (!meta || !action.href) return null
    let href = action.href
    if (action.type === 'START_APPLICATION' && conversationId) {
      const [path, query = ''] = href.split('?')
      const params = new URLSearchParams(query)
      params.set('cid', conversationId)
      href = `${path}?${params.toString()}`
    }
    return {
      id: `${action.type}:${action.courseCode || index}`,
      label: meta.label,
      support: meta.support,
      href,
      actionType: action.type,
    }
  }).filter(Boolean)
}

export async function askAdvisorAi({ message, history, answers, conversationId, messageId }) {
  const { data } = await api.post('/advisor/chat', {
    message,
    history: (history || []).slice(-10).map((item) => ({
      role: item.role,
      text: item.text,
    })),
    answers: answers || {},
    conversationId: conversationId || null,
    ...(messageId ? { messageId } : {}),
  })
  return data
}

export async function requestCourseRecommendation({ answers, conversationId }) {
  const { data } = await api.post('/advisor/recommend', {
    answers: {
      interest: answers?.interest || null,
      goal: answers?.goal || null,
      experience: answers?.experience || null,
      useCase: answers?.useCase || null,
    },
    conversationId: conversationId || null,
  })
  return data
}
